var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 30 28",
    viewBox: "0 0 30 28",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#666666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map-draw-pin-many-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25 12v1h.219l.484 1.936c-.24.052-.468.11-.703.165v1.029c.312-.075.622-.152.945-.222l.585 2.338c-1.798 1.602-4.274 4.423-5.9 8.754h-7.204c-.907-1.281-2.046-2.277-3.283-3.029 1.016-1.033 2.29-2.123 3.857-3.181v-1.249c-2.023 1.283-3.603 2.637-4.813 3.905-2.405-1.214-4.949-1.672-6.558-1.841l.632-2.527c1.063-.278 1.965-.652 2.739-1.085v-1.146c-.683.438-1.485.828-2.462 1.127l1.243-4.974h1.219v-1h-2l-4 16h30l-4-16zm-23.719 15 1.101-4.406c1.451.151 3.825.556 6.089 1.637-.908 1.047-1.563 2.001-2.022 2.769zm6.383 0c.439-.661 1.022-1.435 1.767-2.267 1.01.588 1.962 1.329 2.752 2.267zm21.055 0h-7.005c1.438-3.603 3.491-6.096 5.099-7.626z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.099 13c-.028.079-.068.164-.099.244v2.052c.552-.802.904-1.605 1.122-2.296h1.64c-.206-.307-.359-.646-.485-1h-2.277v1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 15.911c-1.858.579-3.52 1.244-5 1.963v1.149c1.469-.751 3.13-1.449 5-2.055z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 13v-1h-2.276c-.126.354-.279.693-.485 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 13.95v11.05h1v-11.05c1.694-.245 3-1.689 3-3.45 0-1.933-1.566-3.5-3.5-3.5s-3.5 1.567-3.5 3.5c0 1.761 1.306 3.205 3 3.45zm-2-3.45c0-1.381 1.119-2.5 2.5-2.5s2.5 1.119 2.5 2.5-1.119 2.5-2.5 2.5-2.5-1.119-2.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23 18h1v-11.05c1.694-.245 3-1.688 3-3.45 0-1.933-1.566-3.5-3.5-3.5s-3.5 1.567-3.5 3.5c0 1.761 1.306 3.205 3 3.45zm-2-14.5c0-1.381 1.119-2.5 2.5-2.5s2.5 1.119 2.5 2.5-1.119 2.5-2.5 2.5-2.5-1.119-2.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 19h1v-11.05c.353-.052.688-.151 1-.3 1.18-.563 2-1.757 2-3.15 0-1.933-1.566-3.5-3.5-3.5s-3.5 1.567-3.5 3.5c0 1.394.82 2.587 2 3.15.311.149.646.248 1 .3zm-2-14.5c0-1.381 1.119-2.5 2.5-2.5s2.5 1.119 2.5 2.5-1.119 2.5-2.5 2.5-2.5-1.119-2.5-2.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoad);
export default __webpack_public_path__ + "static/media/road.4d94798103a1d69984185f24cf7227d1.svg";
export { ForwardRef as ReactComponent };